<template>
  <div class="app-container operation-log-page">
    <el-card shadow="never">
      <div class="-mb-16px">
        <el-form :model="params" size="small" label-width="80px" inline>
          <el-form-item label="管理员">
            <el-select
              v-model="params.admin_id"
              filterable
              clearable
              :disabled="!isRootAdmin"
              placeholder="全部管理员"
              class="w-180px"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in adminOptions"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="顶部菜单">
            <el-select
              v-model="params.menu_key"
              clearable
              placeholder="全部"
              class="w-150px"
              @change="onMenuChange"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in menuOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="下级菜单">
            <el-select
              v-model="params.module_key"
              clearable
              placeholder="全部"
              class="w-180px"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in filteredModuleOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="操作动作">
            <el-select
              v-model="params.action_key"
              clearable
              placeholder="全部"
              class="w-150px"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in actionOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关键词">
            <el-input
              v-model="params.keyword"
              clearable
              placeholder="账号/对象/内容/IP"
              class="w-190px"
            ></el-input>
          </el-form-item>
          <el-form-item label="时间范围">
            <el-date-picker
              v-model="dateRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="timestamp"
              class="w-360px"
            ></el-date-picker>
          </el-form-item>
          <el-form-item class="ml-6px">
            <el-button type="primary" @click="getList(1)">查询</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="mt-16px" shadow="never">
      <div class="data-table-scroll" style="--table-min-width: 1540px">
        <el-table :data="pager.list" v-loading="pager.loading">
          <el-table-column
            prop="id"
            label="日志ID"
            width="80"
          ></el-table-column>
          <el-table-column label="操作时间" width="160">
            <template v-slot="scope">
              {{ formatDate(scope.row.create_time, "yyyy-mm-dd hh:MM:ss") }}
            </template>
          </el-table-column>
          <el-table-column label="账户类型" width="110">
            <template v-slot="scope">
              {{ scope.row.account_type_name || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="管理员" width="140" show-overflow-tooltip>
            <template v-slot="scope">
              {{ adminText(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="menu_name"
            label="顶部菜单"
            width="90"
          ></el-table-column>
          <el-table-column
            prop="module_name"
            label="下级菜单"
            width="130"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="action_label"
            label="操作动作"
            width="130"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="target_label"
            label="操作对象"
            width="140"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="summary"
            label="操作摘要"
            min-width="260"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="ip" label="IP" width="130"></el-table-column>
          <el-table-column label="技术动作" width="170" show-overflow-tooltip>
            <template v-slot="scope">
              {{ scope.row.action_name || "-" }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-row">
        <pagination
          v-model="pager"
          :pageSizes="[10, 20, 30]"
          @change="getList()"
        ></pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import Pagination from "@/components/pagination";
import { Pager } from "@/utils/pager";
import { formatDate } from "@/utils/util";
import {
  apiAdminOperationLogAdminOptions,
  apiAdminOperationLogList,
} from "@/api/setting";
import { mapGetters } from "vuex";

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      params: {
        admin_id: "",
        menu_key: "",
        module_key: "",
        action_key: "",
        keyword: "",
      },
      dateRange: [],
      pager: new Pager(),
      adminOptions: [],
      menuOptions: [
        { label: "工作台", value: "workbench" },
        { label: "商机", value: "clue" },
        { label: "站点", value: "site" },
        { label: "系统", value: "system" },
        { label: "SEO", value: "seo" },
        { label: "Google 数据", value: "google" },
        { label: "设置", value: "setting" },
      ],
      moduleOptions: [
        { label: "线索列表", value: "clue", menu: "clue" },
        { label: "站点列表", value: "site.list", menu: "site" },
        { label: "管理列表", value: "system.admin", menu: "system" },
        { label: "子账户管理", value: "system.customer", menu: "system" },
        { label: "数据看板", value: "seo.dashboard", menu: "seo" },
        { label: "主词管理", value: "seo.seed", menu: "seo" },
        { label: "关键词管理", value: "seo.keyword", menu: "seo" },
        { label: "消耗统计", value: "seo.cost", menu: "seo" },
        { label: "API 调用日志", value: "seo.api_log", menu: "seo" },
        { label: "自动执行", value: "seo.auto_run", menu: "seo" },
        { label: "SEO系统设置", value: "seo.setting", menu: "seo" },
        { label: "Google 数据", value: "google_data", menu: "google" },
        { label: "系统设置", value: "setting.system", menu: "setting" },
        { label: "邮箱设置", value: "setting.mailer", menu: "setting" },
      ],
      actionOptions: [
        { label: "新增", value: "create" },
        { label: "编辑", value: "edit" },
        { label: "删除", value: "delete" },
        { label: "登录", value: "login" },
        { label: "重置密码", value: "reset_password" },
        { label: "分配权限", value: "permission" },
        { label: "测试", value: "test" },
        { label: "授权", value: "auth" },
        { label: "同步 / 提交", value: "sync" },
        { label: "手动转发", value: "manual_forward" },
      ],
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    isRootAdmin() {
      return Number(this.permission?.root || 0) === 1;
    },
    filteredModuleOptions() {
      if (!this.params.menu_key) {
        return this.moduleOptions;
      }
      return this.moduleOptions.filter(
        (item) => item.menu === this.params.menu_key
      );
    },
  },
  created() {
    this.getAdminOptions();
    this.getList();
  },
  methods: {
    formatDate,
    getList(page) {
      page && (this.pager.page = page);
      this.pager.request({
        callback: apiAdminOperationLogList,
        params: {
          ...this.params,
          ...this.timeParams(),
        },
      });
    },
    getAdminOptions() {
      apiAdminOperationLogAdminOptions().then((resp) => {
        this.adminOptions = resp || [];
        if (!this.isRootAdmin && this.adminOptions.length) {
          this.params.admin_id = this.adminOptions[0].id;
        }
      });
    },
    onReset() {
      this.params = {
        admin_id:
          !this.isRootAdmin && this.adminOptions.length
            ? this.adminOptions[0].id
            : "",
        menu_key: "",
        module_key: "",
        action_key: "",
        keyword: "",
      };
      this.dateRange = [];
      this.getList(1);
    },
    onMenuChange() {
      if (
        this.params.module_key &&
        !this.filteredModuleOptions.some(
          (item) => item.value === this.params.module_key
        )
      ) {
        this.params.module_key = "";
      }
    },
    timeParams() {
      if (!this.dateRange || this.dateRange.length !== 2) {
        return {};
      }
      return {
        start_time: Math.floor(this.dateRange[0] / 1000),
        end_time: Math.floor(this.dateRange[1] / 1000),
      };
    },
    adminText(row) {
      if (row.admin_name && row.admin_account) {
        return `${row.admin_name} / ${row.admin_account}`;
      }
      return row.admin_account || row.admin_name || "-";
    },
  },
};
</script>

<style lang="scss" scoped>
.operation-log-page {
  .pagination-row {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
  }
}
</style>
